var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pagination-server-container" }, [
    _c("div", { staticClass: "pagination" }, [
      _c("span", {
        class: [_setup.icon.left, "icon", "lf-icon__md"],
        on: {
          click: function ($event) {
            return _setup.changePage(-1)
          },
        },
      }),
      _c("div", { staticClass: "number" }, [
        _vm._v(_vm._s(_setup.props.currentPage)),
      ]),
      _c("span", {
        class: [_setup.icon.right, "icon", "lf-icon__md"],
        on: {
          click: function ($event) {
            return _setup.changePage(1)
          },
        },
      }),
    ]),
    _c("div", { staticClass: "pages-info" }, [
      _c("div", { staticClass: "current" }, [
        _vm._v(_vm._s(_setup.props.currentPage)),
      ]),
      _c("div", [_vm._v(_vm._s(_setup.texts.of))]),
      _c("div", [
        _vm._v(_vm._s(_setup.totalPages) + " " + _vm._s(_setup.texts.pages)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }